import React from 'react';
import type { EnrollmentStatus } from '../types';

interface StatusConfig {
  label: string;
  className: string;
}

const STATUS_CONFIG: Record<EnrollmentStatus, StatusConfig> = {
  waitlisted: {
    label: 'Lista d\'attesa',
    className: 'badge badge-yellow',
  },
  portal_registered: {
    label: 'Iscrizione ricevuta',
    className: 'badge badge-gray',
  },
  lms_enrolled: {
    label: 'Iscrizione confermata',
    className: 'badge badge-blue',
  },
  zoom_registration_pending: {
    label: 'Registrazione in corso',
    className: 'badge badge-yellow',
  },
  zoom_registered: {
    label: 'Registrazione completata',
    className: 'badge badge-cyan',
  },
  zoom_approved: {
    label: 'Accesso approvato',
    className: 'badge badge-green',
  },
  join_link_sent: {
    label: 'Link inviato',
    className: 'badge badge-green',
  },
  attended: {
    label: 'Partecipato',
    className: 'badge badge-dark-green',
  },
  no_show: {
    label: 'Non presente',
    className: 'badge badge-red',
  },
  cancelled: {
    label: 'Annullato',
    className: 'badge badge-gray',
  },
};

interface StatusBadgeProps {
  status: EnrollmentStatus | string;
}

export default function StatusBadge({ status }: StatusBadgeProps) {
  const config = STATUS_CONFIG[status as EnrollmentStatus];

  if (!config) {
    return <span className="badge badge-gray">{status}</span>;
  }

  return <span className={config.className}>{config.label}</span>;
}

export function getStatusLabel(status: EnrollmentStatus | string): string {
  const config = STATUS_CONFIG[status as EnrollmentStatus];
  return config?.label ?? status;
}
